import React from "react";
import { Link } from "react-router-dom";
import { MINIO_URL } from "../config";

function GameCard({ game }) {
    return (
        <Link to={`/game/${game.id}`} className="group block bg-gradient-to-br from-[#fbbf24]/90 via-[#f59e0b]/90 to-[#fbbf24]/90 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border-2 border-white/40 hover:border-white/60 backdrop-blur-sm">
            <div className="w-full h-64 bg-[#fcd34d] overflow-hidden relative">
                <img src={`${MINIO_URL}${game.id}/${game.thumb}`} alt={game.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#fbbf24]/90 via-[#f59e0b]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <div className="p-3 bg-gradient-to-br from-[#fbbf24]/90 via-[#f59e0b]/90 to-[#fbbf24]/90 backdrop-blur-sm">
                <div className="font-semibold text-[#78350f] group-hover:text-[#92400e] transition-colors drop-shadow-lg">{game.name}</div>
                <div className="text-xs text-[#92400e] mt-1">{game.category}</div>
            </div>
        </Link>
    );
}
export default GameCard;